// extracted by mini-css-extract-plugin
module.exports = {"userIcon":"AccountEdit_userIcon__KAXYE","footer":"AccountEdit_footer__1ZgP9","blocked":"AccountEdit_blocked__13bF9","active":"AccountEdit_active__cR8wL"};